import { PropTypes } from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

import BusinessInfoFieldset from '#client/components/BusinessInfoFieldset';
import { FIELD_NAMES } from '#client/components/BusinessInfoFieldset/constants';
import Field from '#client/components/Field';
import useFlowState from '#client/hooks/flow/useFlowState';
import {
  getEntityTypeLabelFromValue,
  getJurisdictionStateLabelFromValue
} from '#client/utils/businessInfo';

function BusinessInfoFields({ fieldsConfig: businessInfoFields }) {
  const { businessInfo } = useFlowState();

  const { companyIndicator, entityType, jurisdictionState } = businessInfo;
  const entityTypeLabel = getEntityTypeLabelFromValue(entityType);
  const jurisdictionStateLabel = getJurisdictionStateLabelFromValue(jurisdictionState);

  const fieldsConfig = {
    businessName: {
      autoFocus: false,
      messageKey: 'shopping.page.checkout',
      show: true,
      ...businessInfoFields?.businessName
    }
  };

  return (
    <Stack spacing={1.5}>
      <Heading component="h3" size="md" weight="medium">
        <FormattedMessage id="shopping.page.checkout.business.companyDetails" />
      </Heading>

      <BusinessInfoFieldset fieldsConfig={fieldsConfig} />

      {/* NOTE: These fields display read-only info. No need to store them in the form. */}
      <Field
        defaultValue={entityTypeLabel}
        disabled
        label={
          <FormattedMessage id="shopping.page.checkout.business.form.field.label.entityType" />
        }
        name="entity-type"
      />

      <Field
        defaultValue={jurisdictionStateLabel}
        disabled
        label={
          <FormattedMessage id="shopping.page.checkout.business.form.field.label.filingJurisdiction" />
        }
        name="filing-jurisdiction"
      />

      <input
        data-testid="companyIndicator"
        name={FIELD_NAMES.INDICATOR}
        type="hidden"
        value={companyIndicator ?? ''}
      />
    </Stack>
  );
}

BusinessInfoFields.propTypes = {
  fieldsConfig: PropTypes.shape({
    businessName: PropTypes.object
  })
};

export default BusinessInfoFields;
